import React from 'react';
import './InvoiceLabelSheet.css';

/**
 * Etiqueta da Invoice — 15 cm × 10 cm (paisagem).
 * Provenance / Destination / Destinataire e número da mala.
 */
export default function InvoiceLabelSheet({ invoice, malaIndex, malaTotal }) {
  const destinataire =
    invoice?.cliente ||
    invoice?.cliente_destinatario ||
    invoice?.clientName ||
    '—';
  const provenance = invoice?.origem || '—';
  const destination = invoice?.destino || '—';

  const digits = malaTotal > 99 ? 3 : 2;
  const nStr = String(malaIndex).padStart(digits, '0');

  return (
    <div
      className="inv-label-paper"
      data-invoice-label-sheet
      aria-label={`Etiqueta, mala ${nStr}`}
    >
      <div className="inv-label-paper__texture" aria-hidden />
      <div className="inv-label-parcel">
        <div className="inv-label-parcel__body">
          <div className="inv-label-parcel__top">
            <div className="inv-label-parcel__routes" role="group" aria-label="Provenance e destino">
              <p className="inv-label-parcel__line inv-label-parcel__line--route">
                <span className="inv-label-parcel__k">Provenance:</span>{' '}
                <span className="inv-label-parcel__v">{provenance}</span>
              </p>
              <p className="inv-label-parcel__line inv-label-parcel__line--route">
                <span className="inv-label-parcel__k">Destination:</span>{' '}
                <span className="inv-label-parcel__v">{destination}</span>
              </p>
            </div>

            <div
              className="inv-label-parcel__dest-panel"
              role="group"
              aria-label="Destinataire"
            >
              <div className="inv-label-parcel__dest-inner">
                <div className="inv-label-parcel__dest-title">Destinataire:</div>
                <div className="inv-label-parcel__dest-name">{destinataire}</div>
              </div>
            </div>
          </div>

          <div className="inv-label-parcel__num-wrap">
            <span className="inv-label-parcel__num-only">{nStr}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
